// extracted by css-extract-rspack-plugin
export default {"body":"vYafC","content":"Ifulw","tabsList":"Zt5kC","tabPanel":"UTou0"};